angular.module('app').controller('OrbCtrl', function($http, $controller, $scope, $route, $location, $mdToast, PhotoUtils, $rootScope) {
    "ngInject";

    var main = this;
    main.name = 'orb_order'
    main.photoUtils = PhotoUtils;

    main.afterSave = function(root, response) {
        message = "";
        if(response.data.successes > 0) {
            message += response.data.successes + " sent. "
        }
        if(response.data.failures > 0) {
            message += response.data.failures + " failed."
        }
        var alert = $mdToast.simple().textContent(message);
        $rootScope.updateCounts();
        $mdToast.show(alert);
        $route.reload();
    }
    angular.extend(main, $controller('ItemCtrl', {'$scope': $scope, 'main': main}));

    main.markDelivered = function() {
        $http.post('/api/v1/admin/orb_order/' + main.id + '/delivered').then(
            function(response) {
                var alert = $mdToast.simple().textContent(response.data.message);
                $mdToast.show(alert);
            }
        );
    };

    if(main.id == 'new') {
        main.loading = $http({'method': 'GET', 'url': '/api/v1/admin/orb_order/new', 'params': $location.search()}).then(
            function(response) {
                main.item = response.data;
                main.loading = false
            }
        );
    }
});
